import { PublicLayout } from "../UI/Layout/PublicLayout.tsx";
import { Card } from "../UI/Card.tsx";

export const OneOnOneTypeformThankYouScreenPath =
  "/one-on-one-typeform-thank-you";

export function OneOnOneTypeformThankYouScreen() {
  return (
    <PublicLayout>
      <div className={"flex flex-1 items-center justify-center py-8"}>
        <Card classes={"max-w-[640px] w-full"}>
          <h1 className={"font-bold text-2xl text-center"}>
            Stiamo preparando il tuo Study Plan personalizzato!
          </h1>

          <p className={"text-gray-700"}>
            Ti confermiamo che abbiamo ricevuto con successo le informazioni che
            ci hai fornito e il nostro team sta già lavorando per creare uno
            study plan su misura per te.
          </p>

          <p className={"text-gray-700"}>
            📚 Il tuo percorso sarà progettato per aiutarti a migliorare in modo
            efficace e concreto, passo dopo passo.
          </p>

          <div className={"space-y-3"}>
            <h2 className={"font-bold text-lg"}>Cosa succede adesso?</h2>
            <p className={"text-gray-700"}>
              Entro <span className={"font-semibold"}>10 giorni</span> verrai
              contattato telefonicamente da un nostro consulente della
              didattica, che ti guiderà attraverso tutti i dettagli del corso:
            </p>
            <ul className={"list-disc list-inside space-y-1 text-gray-700"}>
              <li>struttura delle lezioni</li>
              <li>modalità di svolgimento</li>
              <li>obiettivi del percorso</li>
              <li>eventuali domande o dubbi</li>
            </ul>
            <p className={"text-gray-700"}>
              Sarà l'occasione perfetta per conoscere meglio il tuo programma e
              iniziare con il piede giusto!
            </p>
          </div>

          <p className={"text-gray-700 font-medium text-center"}>
            Grazie per la fiducia, non vediamo l'ora di accompagnarti nel tuo
            percorso di apprendimento!
          </p>
        </Card>
      </div>
    </PublicLayout>
  );
}
